export default __webpack_public_path__ + "static/media/logoBlicko.8d4de3eb.svg";